import React, { useState } from "react";
import {
  MenuItem,
  Select,
  SelectChangeEvent,
  ListItemText,
} from "@mui/material";
import { ExpandMore as ExpandIcon } from "@mui/icons-material";
import { COLORS } from "../../styles/constants.style";
import { MuiTypography } from "../typography/MuiTypography";
import { MuiBox } from "../box/MuiBox";
import { OptionsDataType } from "../select/MuiSelect";
import { MuiSelectNavigatorWrapper } from "./MuiSelectNavigator.style";

interface MuiSelectNavigatorProps {
  label?: string;
  id?: string;
  options: OptionsDataType[];
  onNavigate: (value: string | number) => void;
  className?: string;
  disabled?: boolean;
  // here default type is similar to secondary button ui & primary type is similar to primary button ui
  type?: "default" | "primary";
}

export const MuiSelectNavigator = ({
  label,
  id,
  options,
  onNavigate,
  className = "",
  disabled = false,
  type = "default",
}: MuiSelectNavigatorProps) => {
  const [selectedValue, setSelectedValue] = useState<string | number>("");
  const [open, setOpen] = useState(false);

  const labelId = id ? `${id}-label` : undefined;

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    onNavigate(newValue);
  };

  return (
    <MuiSelectNavigatorWrapper
      $type={type}
      className={`mui-select-navigator ${className}`}
    >
      <Select
        value={selectedValue}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={handleChange}
        displayEmpty
        inputProps={{
          "aria-label": label,
          "data-testid": id,
        }}
        MenuProps={{
          PaperProps: {
            className: "custom-menu-paper", // custom class for menuItems popover
          },
        }}
        IconComponent={() => null} // disables default arrow
        className="mui-select"
        disabled={disabled}
        renderValue={(selected) => (
          <MuiBox
            className={`custom-select-content ${open ? "open" : ""}`}
            aria-haspopup="listbox"
          >
            <MuiTypography
              id={labelId}
              className="select-label"
              variant="body3SemiBold"
              color={COLORS.cirrus_black5}
            >
              {label}
            </MuiTypography>
            <div className="vertical-divider" />
            <ExpandIcon
              className={`custom-expand-icon ${open ? "rotated" : ""}`}
            />
          </MuiBox>
        )}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} role="menuitem">
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </MuiSelectNavigatorWrapper>
  );
};
